const { CONSTANTS } = require('../constants/mondelezAPI.constants')

const getConstantsByLocale = locale => {
    const lang = locale.split("-")[0]
    return CONSTANTS[lang] || CONSTANTS.es
}

module.exports = { getConstantsByLocale }
